import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
import { UserModel as UserProjectModel } from '@launchmetrics/dmr-header-component/src/Model/header-models';
import { AuditEntriesModel } from 'components/History Tracking/AuditComponent';

export interface FilterModel {
    Tags: string[];
    WhereType: number;
}

export interface UserModel {
    ProjectId: number;
    ObjectIds: number[];
}

export interface RolesUserModel {
    ProjectId: number;
    TargetId: number;
    ObjectIds: number[];
}

export class UserService {

    axios = useAxios();

    // Define the notification hook
    notification = useNotification();

    // Call the API to get the filters for the current user and project
    async GetMyProjectUsersFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectUsers/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyProjectUsersFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectUsers/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching users: ' + error, 'error');
            console.error('Error fetching users:', error);
            
        }
    }

    // Call the API to add users to the current project
    async AddUsersToProject(userModel: UserModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectUsers/AddUserToProject`, userModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add users: ' + error, 'error');
            console.error('Error add users:', error);
           
        }
    }

    // Call the API to remove users from the current project
    async RemoveUsersFromProject(userModel: UserModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectUsers/RemoveUserFromProject`, userModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove users: ' + error, 'error');
            console.error('Error remove users:', error);
           
        }
    }

    // Call the API to get the filters for the current user and project
    async GetMyUsersFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Users/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };            
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyUsersFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Users/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching users: ' + error, 'error');
            console.error('Error fetching users:', error);
           
        }
    }

    // Call the Api to add Roles to User
    async AddRolesToUser(roleUserModel: RolesUserModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectUserRoles/AddRoleToUser`, roleUserModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add roles: ' + error, 'error');
            console.error('Error add roles:', error);
           
        }
    }

    // Call the Api to remove Roles from User  
    async RemoveRolesFromUser(roleUserModel: RolesUserModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectUserRoles/RemoveRoleFromUser`, roleUserModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove roles: ' + error, 'error');
            console.error('Error remove roles:', error);
           
        }
    }

    async GetUser (): Promise<any> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Users/GetCurrentUser`);
            const userData= response.data;
            localStorage.setItem("sso-auth-user", userData.Username ||"");    
            localStorage.setItem('sso-auth-userId', userData.UserId);
            const user: UserProjectModel = {
                UserId: userData.UserId,
                UserName: userData.Username,
                LogoutLink: '/logout',
            };
            return user;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching user: ' + error, 'error');
            console.error('Error fetching user:', error);
            return null;
        }
    }

    async GetAudit(userId: number): Promise<AuditEntriesModel[]>{
        try {
            const response = await this.axios.get(config.API_URL + "/api/Users/GetAudit?userId=" + userId);
            return response.data;
        }
        catch (error: any) {
            this.notification.showNotification("Error getting user audit history: " + error, 'error');
            console.error("Error getting user audit history: ", error);
            return {} as AuditEntriesModel[];
        }
    }
}